module.exports = __webpack_public_path__ + "img/function-click-001.ee9fa669.png";